import React from 'react';
import { EllipsisVertical } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { cn } from '@/lib/utils';

export function BlockSectionMenuShell({
  menuOpen,
  onMenuOpenChange,
  ariaLabel,
  children,
  className,
}: {
  menuOpen: boolean;
  onMenuOpenChange: (open: boolean) => void;
  ariaLabel: string;
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  return (
    <div className={cn('block-section-menu', className)} contentEditable={false}>
      <DropdownMenu modal={false} open={menuOpen} onOpenChange={onMenuOpenChange}>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="block-section-menu-trigger"
            aria-label={ariaLabel}
            onMouseDown={(event) => {
              event.preventDefault();
            }}
          >
            <EllipsisVertical className="h-4 w-4" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          side="bottom"
          className="z-[2100] min-w-[10rem] max-w-[18rem]"
          onOpenAutoFocus={(event) => {
            event.preventDefault();
          }}
          onCloseAutoFocus={(event) => {
            event.preventDefault();
          }}
          onFocusOutside={(event) => {
            event.preventDefault();
          }}
        >
          {children}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
